import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'next/components/ui';
import { ChecklistsShape } from 'next/entities/rules';

import { ConditionsContext } from './ConditionsContext';
import { Clause } from './styled';

const STATUS_OPTIONS = [
  { label: 'is in progress', value: 'in_progress' },
  { label: 'has been skipped', value: 'skipped' },
  { label: 'has been completed', value: 'completed\ndismissed' },
  {
    label: 'has not been seen',
    value: null,
  },
];

export const ChecklistsClause = ({ conditions, onChange }) => {
  const {
    checklists: { checklist, status = null },
  } = conditions;

  const { checklistOptions } = useContext(ConditionsContext);

  const handleChange = changes => {
    onChange({ checklists: { ...conditions.checklists, ...changes } });
  };

  const handleChecklistChange = ({ value: newChecklist }) =>
    handleChange({ checklist: newChecklist });

  const handleStatusChange = ({ value: newStatus }) => {
    handleChange({ status: newStatus });
  };

  const options = [...checklistOptions];

  if (
    checklist &&
    !checklistOptions.some(
      ({ value: checklistId }) => checklistId === checklist
    )
  ) {
    options.push({ label: checklist, value: checklist });
  }

  return (
    <Clause>
      <Select
        value={options.find(({ value }) => value === checklist)}
        options={options}
        onChange={handleChecklistChange}
        portal
      />
      <Select
        value={STATUS_OPTIONS.find(({ value }) => value === status)}
        options={STATUS_OPTIONS}
        onChange={handleStatusChange}
        portal
      />
    </Clause>
  );
};

ChecklistsClause.propTypes = {
  conditions: ChecklistsShape,
  onChange: PropTypes.func,
};
